import { openBlock as r, createElementBlock as s, createTextVNode as h, toDisplayString as i, createElementVNode as a } from "vue";
/* empty css                    */
/* empty css                    */
import c from "./design-system.es128.js";
const f = {
  name: "DsTextHighlighter",
  props: {
    /**
     * String part to be highlighted
     */
    highlight: {
      type: String,
      default: ""
    },
    /**
     * Full string value to be displayed
     */
    content: {
      type: String,
      required: !0
    }
  },
  computed: {
    showHighlight() {
      return !!this.highlight && this.matchingValue.length > 0;
    },
    prefixEnd() {
      return this.highlight && this.content ? this.content.toLowerCase().indexOf(this.highlight.toLowerCase()) : -1;
    },
    suffixStart() {
      const t = this.prefixEnd;
      return t > -1 ? t + this.highlight.length : -1;
    },
    prefixValue() {
      const t = this.prefixEnd;
      return t > 0 ? this.content.substring(0, t) : "";
    },
    matchingValue() {
      const t = this.prefixEnd, n = this.suffixStart;
      return t > -1 && n > -1 ? this.content.substring(t, n) : "";
    },
    suffixValue() {
      const t = this.suffixStart;
      return t > -1 ? this.content.substring(t) : "";
    }
  }
}, u = { key: 0 }, g = { class: "matching" }, l = { key: 1 };
function x(t, n, o, d, p, e) {
  return r(), s("span", null, [
    e.showHighlight ? (r(), s("span", u, [
      h(i(e.prefixValue), 1),
      a("span", g, i(e.matchingValue), 1),
      h(i(e.suffixValue), 1)
    ])) : (r(), s("span", l, i(o.content), 1))
  ]);
}
const S = /* @__PURE__ */ c(f, [["render", x], ["__scopeId", "data-v-72738241"]]);
export {
  S as default
};
//# sourceMappingURL=design-system.es109.js.map
